import HcNavigation from '../components/HcNavigation'
import HcBanner from '../components/HcBanner'
import HcFooter from '../components/HcFooter'

export default {
  components: {
    HcNavigation, HcBanner, HcFooter
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Components.js